import getBrowserInfo from './getBrowserInfo';

export default function isMinimumBrowserVersion(minimumVersion: number[]) {
    const { browserVersion } = getBrowserInfo();

    if (minimumVersion.length > browserVersion.length) {
        return false;
    }

    return minimumVersion.reduce(
        (isSupported, buildSubNumber, index) =>
            isSupported && browserVersion[index] >= buildSubNumber,
        true
    );
}
